const listDays = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday',
]
export {
  listDays
}